// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { THIRTY_SECONDS_MS } from '@/utilities/time-constants';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

interface MaintenanceStatusResponse {
  maintenance: boolean;
}

async function checkMaintenanceStatus(): Promise<boolean> {
  const response = await fetch('/_maintenance-status');
  if (!response.ok) return false;
  const data = (await response.json()) as MaintenanceStatusResponse;
  return data.maintenance;
}

/**
 * A React hook that polls the maintenance status endpoint every 30 seconds.
 * When maintenance mode is detected, it forces a page reload so the Edge
 * Middleware can serve the maintenance page.
 */
export function useMaintenanceCheck(): void {
  const { data: isMaintenanceMode } = useQuery({
    queryKey: ['maintenance-status'],
    queryFn: checkMaintenanceStatus,
    refetchInterval: THIRTY_SECONDS_MS,
    refetchIntervalInBackground: true, // Keep polling even when tab is hidden
  });

  useEffect(() => {
    if (isMaintenanceMode) {
      window.location.reload();
    }
  }, [isMaintenanceMode]);
}
